import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Nav from './Nav';
import { Location } from './Location';
import { Songs } from './Songs';
import { Home } from './Home';
import { Footer } from './Footer';
import ScrollToTop from './ScrollToTop';

function App() {
    return (
        <div className="App">
            <Nav/>
            {/*<div className="homepage-hero-container"></div>*/}
            <ScrollToTop/>
            <Routes>
                <Route index element={<Home/>}/>
                <Route path="location/:locationNum" element={<Location/>}/>
                <Route path="songs" element={<Songs/>}/>
                <Route path="*" element={<Home/>}/>
            </Routes>
            <Footer/>
        </div>
    );
}

export default App;
